module.exports = __webpack_public_path__ + "static/media/logo-full.2b03ae71.jpg";